/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 17:37
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-11 18:04
 * @FilePath: \glyun_web_Vue3\src\router\intelligentQuery.js
 * @Description: 智能查询路由
 */
export default [
  {
    path: '/intelligentQuery',
    redirect: '/intelligentQuery/inverterDashboard',
    name: 'intelligentQuery',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//逆变器仪表盘
        path: 'inverterDashboard',
        name: 'intelligentQueryInverterDashboard',
        component: () => import('../views/intelligentQuery/inverterDashboard/index.vue'),
        meta: {
          title: 'v2_inverter_dashboard',
          routeAuthCode: 'A1000',
        },
      },
      {//数据查询
        path: 'dataQuery',
        name: 'intelligentQueryDataQuery',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'intelligentQueryDataQueryInverter',
            component: () => import('../views/intelligentQuery/dataQuery/inverter/index.vue'),
            meta: {
              title: 'v2_device_inverter',
              routeAuthCode: 'A100100',
            },
          },
        ],
      },
      {//数据字典
        path: 'dataDictionary',
        name: 'intelligentQueryDataDictionary',
        component: () => import('../views/intelligentQuery/dataDictionary/index.vue'),
        meta: {
          title: 'v2_data_dictionary',
          routeAuthCode: 'A1002',
        },
      },
      {//采集器仪表盘
        path: 'collectorDashboard',
        name: 'intelligentQueryCollectorDashboard',
        component: () => import('../views/intelligentQuery/collectorDashboard/index.vue'),
        meta: {
          title: 'v2_datalogger_dashboard',
          routeAuthCode: 'A1003',
        },
      },
    ],
  },
]

